import { Component, OnInit } from '@angular/core';
import { ChannelPartnerService } from 'src/app/services/ChannelPartner/channel-partner.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ConfirmationDialogService } from 'src/app/services/sal/confirmation-dialog.service';
import { GroupAdminService } from 'src/app/services/GroupAdmin/group-admin.service';

@Component({
  selector: 'app-group-create-branch',
  templateUrl: './group-create-branch.component.html',
  styleUrls: ['./group-create-branch.component.css']
})
export class GroupCreateBranchComponent implements OnInit {

  
  Submitted: boolean = false;
  UserIDMsg:any;
  BranchList: any;
  School:any;
  Country: any;
  State: any;
  City: any;
  CurrencyList:any;
  SelectedFileForUpload: any;
  Count:number=0;
  SchoolBrachResetList:any;

  constructor(private modalService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    private router: Router, private superadminservice: ChannelPartnerService, private lookupservice: LookupService, 
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService,
    private groupadminservice: GroupAdminService 
    ) { }

  BranchModel = {
    City: '',
    LogoPath: '',
    CountryName:"",
    StateName:"",
    GroupName:"",
    CurrencySymbol:"",
    OrderNo:"",
    PackageSaleID:0,
    BillingCycleID:0,
            BranchID: 0,
            SchoolID: 0,
            TotalAmount:0,
            BranchName: '',
            JosaBranchCode:'',
            BranchCode: '',
            OwnerName: '',
            Phone: '',
            AffiliationFrom: '',
            ContactNo: '',
            ContactPerson: '',
            IsActive: true,
            AffiliationNo: '',
            CityID: 0,
            StateID: 0,
            CountryID: 0,
            ZipCode: '',
            Address: '',
            StaffName: '',
            UserID: '',
            Password: '',
            CurrencyID: 0,
            DecimalPlace: 0,
            IsPG: false,
            IsGRDisplay:true,
            GRType: "AUTO",
            IsSubBranch:false,
            POBox:'',
            Email:'',
            Fax:'',
            CurrencyRate:0,
            CurrencyCode:"",
            StudentStrangth:150,
          
          
  };

  Clear() {
    this.PackagePriceList=null;
    this.BranchModel.GroupName = '';
    this.BranchModel.LogoPath = '';
    this.BranchModel.StudentStrangth = 150;
    this.BranchModel.BillingCycleID = 0;
    this.BranchModel.PackageSaleID = 0;
    this.BranchModel.BranchID = 0;
    this.BranchModel.BranchName = '';
    this.BranchModel.BranchCode = '';
    this.BranchModel.JosaBranchCode = '';
    this.BranchModel.POBox = '';
    this.BranchModel.OwnerName = '';
    this.BranchModel.Phone = '';
    this.BranchModel.AffiliationFrom = '';
    this.BranchModel.ContactNo = '';
    this.BranchModel.ContactPerson = '';
    this.BranchModel.IsActive = false;
    this.BranchModel.AffiliationNo = '';
    this.BranchModel.CityID = 0;
    this.BranchModel.CountryID = 0;
    this.BranchModel.StateID = 0;
    this.BranchModel.ZipCode = '';
    this.BranchModel.Address = '';
    this.BranchModel.Email = '';
    this.BranchModel.Fax = '';
    this.BranchModel.CurrencyRate = 0;
    this.BranchModel.CurrencyCode = '';
    this.Submitted = false;
    this.BranchModel.StaffName = '';
    this.BranchModel.UserID = '';
    this.BranchModel.Password = '';
    this.BranchModel.OrderNo = '';
    this.BranchModel.CurrencyID = 0;
    this.BranchModel.DecimalPlace = 0; 
    this.BranchModel.IsPG = false;
    this.BranchModel.IsGRDisplay = true;
    this.UserIDMsg = '';
    this.BranchModel.GRType = "AUTO";
    this.BranchModel.IsSubBranch = false;
   
  };



 

  validationDropDown() {
    return  this.BranchModel.CountryID == 0 ||this.BranchModel.StateID == 0;
  }



 

  ngOnInit() {
    this.GetBillingCycle();
    this.GetPackageSale();
    this.GetBindCountry();    
    this.GetCurrency();
    this.GetBranchSchool();

  }

 

  GetBindCountry() {
    this.lookupservice.GetLookupsList('Country', '').subscribe((data: any) => {
      this.Country = data.LookupItems;
    });
  };
  PackageSaleList:any;
  GetPackageSale() {
    this.lookupservice.GetLookupsList('PackageSale', '').subscribe((data: any) => {
      this.PackageSaleList = data.LookupItems;
    });
  };
  BillingCycleList:any;
  GetBillingCycle() {
    this.lookupservice.GetLookupsList('BillingCycle', '').subscribe((data: any) => {
      this.BillingCycleList = data.LookupItems;
    });
  };
  GetCurrency() {
    this.lookupservice.GetLookupsList('Currency', '').subscribe((data: any) => {
      this.CurrencyList = data.LookupItems;
    });
  };


  GetBranchState() {
    var Itembo = {
      'ItemId': this.BranchModel.CountryID
    }
    this.lookupservice.GetLookupsList('State', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.State = data.LookupItems;
    });
  };

 
  GetBranchCity() {
    var Itembo = {
      'ItemId': this.BranchModel.StateID
    }
    this.lookupservice.GetLookupsList('City', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.City = data.LookupItems;
    });
  };
  UserList:any;
  IsExitsBranchCode=false;
  CheckBranchCodeExists() {
    this.IsExitsBranchCode=false;
    this.superadminservice.CheckBranchCodeExists(this.BranchModel.BranchCode).subscribe((response: any) => {
      
      this.UserList = response.UserList;
   
      if(this.UserList!=null && this.UserList.length>0 ){
      this.IsExitsBranchCode=true;
     
      }
  
    });
  }
  IsExitsEmail=false;
  CheckUserExists() {
   this.IsExitsEmail=false;
    this.superadminservice.CheckUserExists(this.BranchModel.Email).subscribe((response: any) => {
      this.UserList = response.UserList;
     
      if(this.UserList!=null && this.UserList.length>0 ){
      // this.IsExitsEmail=true;
      
      }
  
    });
    
  }
  



 

TotalAmount:any;
PackagePriceList:any;
GetAllPackagePrice() {
  this.PackagePriceList=null;
  if(this.BranchModel.PackageSaleID>0 && this.BranchModel.BillingCycleID>0 && this.BranchModel.StudentStrangth>=150){ 
  this.spinnerService.show();
  this.groupadminservice.GetAllPackagePrice(JSON.stringify(this.BranchModel)).subscribe((response: any) => {
    this.PackagePriceList = response.PackagePriceList;
    this.TotalAmount=0;
    for (var i = 0; i < this.PackagePriceList.length; i++) {
      this.TotalAmount=this.TotalAmount+this.PackagePriceList[i].Price
      this.BranchModel.CurrencyCode=this.PackagePriceList[i].CurrencyCode;
      this.BranchModel.CurrencyRate=this.PackagePriceList[i].CurrencyRate;
      this.BranchModel.CurrencyID=this.PackagePriceList[i].CurrencyID;
      this.BranchModel.CurrencySymbol=this.PackagePriceList[i].CurrencySymbol;
    }
    this.BranchModel.TotalAmount=this.TotalAmount;
    this.spinnerService.hide();

  });
}
};
OrderNo:"";
josaBranchCode:any;
RegisterSchool(valid) {
  this.Submitted = true;
  if (valid && !this.validationDropDown() && !this.IsExitsEmail && !this.IsExitsBranchCode) {
  this.spinnerService.show();
  this.groupadminservice.RegisterGroupSchool(JSON.stringify(this.BranchModel),JSON.stringify(this.PackagePriceList)).subscribe((response: any) => {
  if(response.webResponse.Status){
    this.OrderNo = response.OrderNo;
    this.BranchModel.OrderNo = response.OrderNo;
    this.josaBranchCode = response.josaBranchCode;
  }
   
   
    this.spinnerService.hide();

  });
}
};

Pay() {
  this.confirmationDialogService.confirm('Please confirm..', 'Please click on OK to pay this order or Cancel to go back. ?')

    .then(confirmed => {
      if (confirmed) {
        window.localStorage.removeItem("ReceiptNo");
        window.localStorage.removeItem("razorpay_payment_id");
        window.localStorage.removeItem("razorpay_signature");
        window.localStorage.removeItem("razorpay_order_id");
        this.router.navigate(['/pay'], { state: { OrderNo: this.OrderNo } })
      }
    })
    .catch(err => {
      console.log(err);
    });
}
onSelectGroup(item){

}

GetBranchSchool() {
  this.lookupservice.GetLookupsList('PartnerGroup', '').subscribe((data: any) => {
    this.School = data.LookupItems;
  });
};

}



